import React from "react";


export const BalanceIcon: React.FC<CustomIconProps> = ({
  width = 20,
  height = 21,
  color = "#000000",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 17.0156V15.5156H9.25V6.39062C8.93056 6.27951 8.64931 6.10243 8.40625 5.85938C8.16319 5.61632 7.98611 5.33507 7.875 5.01562H5L7.5 10.7656C7.48611 11.4462 7.20139 11.9913 6.64583 12.401C6.09028 12.8108 5.45833 13.0156 4.75 13.0156C4.04167 13.0156 3.40972 12.8108 2.85417 12.401C2.29861 11.9913 2.01389 11.4462 2 10.7656L4.5 5.01562H3V3.51562H7.86771C8.02535 3.07118 8.29792 2.71007 8.68542 2.43229C9.07292 2.15451 9.51042 2.01562 9.99792 2.01562C10.4854 2.01562 10.9236 2.15451 11.3125 2.43229C11.7014 2.71007 11.9747 3.06875 12.1323 3.50833H17V5.01562H15.5L18 10.7606C18 11.4445 17.7222 11.9913 17.1667 12.401C16.6111 12.8108 15.9757 13.0156 15.2604 13.0156C14.5451 13.0156 13.9097 12.8108 13.3542 12.401C12.7986 11.9913 12.5139 11.4462 12.5 10.7656L15 5.01562H12.125C12.0139 5.33507 11.8368 5.61632 11.5938 5.85938C11.3507 6.10243 11.0694 6.27951 10.75 6.39062V15.5156H18V17.0156H2ZM13.5833 10.7656H16.9167L15.25 6.95312L13.5833 10.7656ZM3.08333 10.7656H6.41667L4.75 6.95312L3.08333 10.7656ZM9.99563 5.01562C10.2069 5.01562 10.3854 4.94417 10.5312 4.80125C10.6771 4.65833 10.75 4.48125 10.75 4.27C10.75 4.05875 10.6785 3.88021 10.5356 3.73438C10.3927 3.58854 10.2156 3.51562 10.0044 3.51562C9.79313 3.51562 9.61458 3.58708 9.46875 3.73C9.32292 3.87292 9.25 4.05 9.25 4.26125C9.25 4.4725 9.32146 4.65104 9.46438 4.79688C9.60729 4.94271 9.78438 5.01562 9.99563 5.01562Z"
        fill={color}
      />
    </svg>
  );
};
